import React, { FC } from 'react';
import { Borrower } from '../../../interfaces';
import ListTile from '../../Common/ListTile';

type Props = {
  borrower: Borrower;
};

export const BorrowerInfo: FC<Props> = ({ borrower }) => {
  return (
    <>
      <h4 className='mtitle'>Borrower Detail</h4>
      <ListTile title='Name' value={`${borrower.user.firstname} ${borrower.user.lastname}`} />
      <ListTile title='Address' value={`${borrower.address}, ${borrower.address_city}, ${borrower.address_state.name}, ${borrower.address_country.name}`} />
      <ListTile title='Occupation' value={borrower.occupation} />
      <ListTile title='Job Title/Position' value={borrower.job_title!} />
      <ListTile title='Self Employed' value={`${borrower.is_self_employed ? 'Yes' : 'No'}`} />
      {borrower.is_self_employed ? (
        <>
          <ListTile title='Business Name' value={borrower.business_name!} />
          <ListTile title='RC No' value={borrower.rc_no!} />
          <ListTile title='Business Type' value={borrower.business_type!} />
          <ListTile title='Business Duration' value={`${borrower.duration!} year${borrower.duration! > 1 && 's'}`} />
          <ListTile title='Business Location' value={`${borrower.business_city}, ${borrower.business_state?.name}, ${borrower.business_country?.name}`} />
        </>
      ) : (
        <>
          <ListTile title='Employer Name' value={borrower.employer_name!} />
          <ListTile title='Employer Location' value={`${borrower.employer_city}, ${borrower.employer_state?.name}, ${borrower.employer_country?.name}`} />
          <ListTile title='Employment Duration' value={`${borrower.duration!} year${borrower.duration! > 1 ? 's' : ''}`} />
        </>
      )}

      {borrower.linkedin && (
        <ListTile title='LinkedIn Profile'>
          <a href={borrower.linkedin} target='_blank' rel='noopener noreferrer'>
            {borrower.linkedin}
          </a>
        </ListTile>
      )}

      {borrower.work_prove && (
        <ListTile title='Prove of Work'>
          <a className='btn btn-sm btn-light-success' href={borrower.work_prove} target='_blank' rel='noopener noreferrer'>
            View
          </a>
        </ListTile>
      )}

      {borrower.income_prove && (
        <ListTile title='Prove of Income'>
          <a className='btn btn-sm btn-light-success' href={borrower.income_prove} target='_blank' rel='noopener noreferrer'>
            View
          </a>
        </ListTile>
      )}
    </>
  );
};
